import base from "./base";
import { extendTheme } from "./utils";

export default extendTheme(base, {
    primary: '#C7B527',
    primaryDark: '#C7B527',

    logoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/rettinger-logo.png',
    smallLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/rettinger-small.png',
    loadingLogoUrl: 'https://intertaxexpertstaging.blob.core.windows.net/frontend-cdn/rettinger-logo.png',

    availableProducts: ["Schadenmeldung", "smartKV", "Reparaturnachweis", "Zustandsbericht"],
});